import {OrderListConfig} from "../../components/orders/models/OrderListConfig";
import DefaultOpenOrdersColumns from "./DefaultOpenOptionOrdersColumns";
import {WorkingOrderListOrderBy} from "../../components/orders/models/WorkingOrderListOrderBy";
import DefaultCompletedOrdersColumns from "./DefaultCompletedOptionOrdersColumns";

export default {
    working: {
        columns: DefaultOpenOrdersColumns,
        order: WorkingOrderListOrderBy.ASX_CODE
    },
    completed: {
        columns: DefaultCompletedOrdersColumns,
        includeUnfilled: false
    }
} as OrderListConfig;
